// import loadable from "@loadable/component"
import PropTypes from "prop-types"
import { useRef } from "react"
// import { useSelector } from "react-redux"

// import { retry } from "helpers/application"

import ProductAddons from "./product-addons"
import WizardActions from "./wizard-actions"
import WizardHeader from "./wizard-header"
import WizardOptions from "./wizard-options"

// const WarrantyOptions = loadable(() =>
//   retry(() => import("./warranty-options"))
// )

const MainBody = ({ imageAreaRef, outOfStockRef }) => {
  const wizardRef = useRef()

  return (
    <>
      <WizardHeader />
      <section aria-label="Product Options" ref={wizardRef}>
        <WizardOptions />
        {/* {pdpWarrantyExp === 1 && <WarrantyOptions />} */}
        <ProductAddons />
      </section>
      <div className="border-t-grey-10 tablet:border-none pt-18 pb-18 tablet:pt-16 tablet:pb-0 border-t">
        <WizardActions
          imageAreaRef={imageAreaRef}
          outOfStockRef={outOfStockRef}
          wizardRef={wizardRef}
        />
      </div>
    </>
  )
}

MainBody.propTypes = {
  imageAreaRef: PropTypes.object,
  outOfStockRef: PropTypes.object,
}

export default MainBody
